import { makeAutoObservable, runInAction } from 'mobx'

import { LoadUserHistoryTask } from '../Tasks/LoadUserHistoryTask'

import type { UserHistoryItem } from '../Contracts/IUser'

/** Стрічка «Історія змін» картки співробітника; екземпляр — на змонтовану вкладку. */
export class UserHistoryManager {
    items: UserHistoryItem[] = []
    /** Скільки подій усього — якщо більше, ніж показано, стрічка про це скаже */
    total = 0
    isLoading = false
    /** Запит не вдався: порожня стрічка тоді означала б неправду «змін не було» */
    failed = false

    constructor() {
        makeAutoObservable(this)
    }

    async load(uuid: string | undefined): Promise<void> {
        if (!uuid) return

        this.isLoading = true
        this.failed = false

        try {
            const page = await LoadUserHistoryTask(uuid)

            runInAction(() => {
                this.items = page.items
                this.total = page.total
            })
        } catch {
            runInAction(() => {
                this.items = []
                this.total = 0
                this.failed = true
            })
        } finally {
            runInAction(() => {
                this.isLoading = false
            })
        }
    }
}
